
import React from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'

const TermsOfService = () => {
  const today = new Date().toLocaleDateString('en-US', { 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  })

  return (
    <div className="min-h-screen bg-background py-12">
      <Helmet>
        <title>Terms of Service | DesistIt!</title>
        <meta name="description" content="Review the terms and conditions for using DesistIt!'s cease and desist letter generation services. Understand your rights and responsibilities when using our platform." />
        <link rel="canonical" href="https://desistit.com/terms" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Terms of Service",
            "description": "DesistIt! terms of service outlining the conditions for using our cease and desist letter services.",
            "publisher": {
              "@type": "Organization",
              "name": "DesistIt!",
              "logo": "https://www.poweredbyeducation.org/wp-content/uploads/2025/02/DESIST2.png"
            },
            "datePublished": today,
            "dateModified": today
          })}
        </script>
      </Helmet>
      
      <div className="container mx-auto px-4 max-w-4xl">
        <h1 className="text-5xl font-serif font-bold mb-8 text-center">Terms of Service</h1>
        
        <div className="text-center text-gray-600 mb-12">
          <p>Updated {today} | Published {today}</p>
          <p className="mt-4">By DesistIt! staff</p>
        </div>
        
        <div className="prose prose-lg max-w-none text-left">
          <p className="text-xl">Welcome to DesistIt! ("Company," "we," "us," or "our"). By accessing or using our website, desistit.com (the "Website"), and our services (the "Services"), you agree to comply with and be bound by these Terms of Service ("Terms"). If you do not agree with any part of these Terms, you may not use our Services.</p>
          
          <h2>1. Acceptance of Terms</h2>
          <p>By using our Services, you acknowledge that you have read, understood, and agree to be bound by these Terms. We may modify these Terms at any time, and continued use of the Services constitutes acceptance of the updated Terms.</p>
          
          <h2>2. Description of Services</h2>
          <p>DesistIt! provides an online platform for generating cease and desist letters. While our platform uses professional standards to create these letters, we are not a law firm and do not provide legal advice. The letters generated through our Services are not a substitute for legal representation.</p>
          
          <h2>3. Eligibility</h2>
          <p>To use our Services, you must be at least 18 years old or have parental/legal guardian consent. By using our Services, you represent that you have the legal capacity to enter into these Terms.</p>
          
          <h2>4. User Responsibilities</h2>
          <ul>
            <li>You agree to use the Services in compliance with all applicable laws and regulations.</li>
            <li>You are responsible for ensuring that the information provided for generating a cease and desist letter is accurate and truthful.</li>
            <li>You understand that misuse of our Services, including but not limited to submitting false or defamatory claims, may result in the suspension or termination of your account.</li>
          </ul>
          
          <h2>5. No Legal Advice & Disclaimer</h2>
          <p>DesistIt! is not a law firm and does not provide legal advice. Any content, letter, or service provided is for informational purposes only. If you require legal assistance, we recommend consulting a licensed attorney.</p>
          
          <h2>6. Payments & Refund Policy</h2>
          <ul>
            <li>All payments for Services are due at the time of purchase.</li>
            <li>Fees are non-refundable unless a technical error caused by DesistIt! prevents delivery of the service.</li>
            <li>We reserve the right to change pricing at any time without prior notice.</li>
          </ul>
          
          <h2>7. Intellectual Property</h2>
          <p>All content on our Website, including text, graphics, logos, and software, is owned by or licensed to DesistIt! and is protected by copyright, trademark, and other intellectual property laws.</p>
          
          <h2>8. Limitation of Liability</h2>
          <p>To the fullest extent permitted by law, DesistIt! shall not be liable for any indirect, incidental, consequential, or punitive damages arising from your use of our Services. Our total liability shall not exceed the amount you paid for the Services.</p>
          
          <h2>9. Indemnification</h2>
          <p>You agree to indemnify and hold harmless DesistIt!, its officers, employees, and affiliates from any claims, damages, or liabilities resulting from your use of the Services.</p>
          
          <h2>10. Termination</h2>
          <p>We reserve the right to terminate or suspend your access to our Services at any time if we believe you have violated these Terms.</p>
          
          <h2>11. Governing Law & Dispute Resolution</h2>
          <p>These Terms are governed by the laws of the State of Tennessee, without regard to conflict of law principles. Any disputes shall be resolved through binding arbitration in Tennessee.</p>
          
          <h2>12. Contact Information</h2>
          <p>For any questions regarding these Terms, please <Link to="/" className="text-[#29b554] hover:underline">contact us</Link>.</p>
        </div>
      </div>
    </div>
  )
}

export default TermsOfService
